import React from 'react';

import { DatasetsIcon } from 'pages/Landings/components/Icons';
import Paragraph from 'pages/Landings/components/Paragraph';
import TopicContent from 'pages/Landings/components/TopicContent';
import TopicHeading from 'pages/Landings/components/TopicHeading';
import TopicTemplate from 'pages/Landings/components/TopicTemplate';

const Datasets: React.FC = () => {
    return (
        <TopicTemplate
            heading={
                <TopicHeading
                    title="Datasets"
                    description="Fetch the connected world of vulnerability intelligence. Export full datasets and see how CVEs, advisories, exploits, and observations link together."
                    illustration={<DatasetsIcon />}
                />
            }
            content={
                <TopicContent link="https://docs.vulners.com/docs/products/datasets/">
                    <Paragraph
                        primary="Unified, Graph-Linked Foundation"
                        secondary="Build analytics on top of a unified, graph-linked database that ties together CVEs, vendor advisories, exploits, patches, and correlated observations. Everything is normalized and ready for on-prem ingestion or data-lake pipelines, so you can enrich events entirely in-house."
                    />
                    <Paragraph
                        primary="Always in Sync with Archive API"
                        secondary="Stay perfectly in sync with the Archive API. Pull full collections on a schedule - updated every few hours - with add/update timestamps for reproducibility. That consistency lets you audit, rerun experiments, and keep downstream models aligned with the source of truth."
                    />
                    <Paragraph
                        primary="Built for Research and ML Velocity"
                        secondary="For research and ML, the structure pays off. Mine how advisories and social networks relate to each other, correlate exploit links, trend patch latency, and model exploit likelihood from consistent JSON. Coverage spans hundreds of sources, cross-referenced and quality-checked, so you can stop stitching feeds and start shipping features. The result: faster analytics, clearer relationships, and less operational drag for platforms, researchers, and security data teams."
                    />
                </TopicContent>
            }
        />
    );
};

export default Datasets;
